import inputTypes from "../inputTypes";

const { TRAP } = inputTypes;

export default {
  SINEW_SLICER: {
    INTERNAL_ID: "STANDARDTURRET",
    TYPE: TRAP,
    NAME: "Sinew Slicer",
  },
  WOLF_TRAP: {
    INTERNAL_ID: "ROOTTRAP",
    TYPE: TRAP,
    NAME: "Wolf Trap",
  },
  CROSSBOMATIC: {
    INTERNAL_ID: "HORIZONTALTURRET",
    TYPE: TRAP,
    NAME: "Double Crossb-o-matic",
  },
  HEAVY_TURRET: {
    INTERNAL_ID: "HEAVYTURRET",
    TYPE: TRAP,
    NAME: "Heavy Turret",
  },
  BARNACLE: {
    INTERNAL_ID: "CEILTURRET",
    TYPE: TRAP,
    NAME: "Barnacle",
  },
  FLAMETHROWER_TURRET: {
    INTERNAL_ID: "FIRETURRET",
    TYPE: TRAP,
    NAME: "Flamethrower Turret",
  },
  CLEAVER: {
    INTERNAL_ID: "GROUNDSAW",
    TYPE: TRAP,
    NAME: "Cleaver",
  },
  CRUSHER: {
    INTERNAL_ID: "CRUSHER",
    TYPE: TRAP,
    NAME: "Crusher",
  },
  DECOY: {
    INTERNAL_ID: "DECOY",
    TYPE: TRAP,
    NAME: "Explosive Decoy",
  },
  DOOR: {
    INTERNAL_ID: "PORTABLEDOOR",
    TYPE: TRAP,
    NAME: "Emergency Door",
  },
  TESLA_COIL: {
    INTERNAL_ID: "TESLACOIL",
    TYPE: TRAP,
    NAME: "Tesla Coil",
  },
};
